import { render, staticRenderFns } from "./form-setting.vue?vue&type=template&id=f95d5144&scoped=true&"
import script from "./form-setting.vue?vue&type=script&lang=js&"
export * from "./form-setting.vue?vue&type=script&lang=js&"
import style0 from "./form-setting.vue?vue&type=style&index=0&id=f95d5144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95d5144",
  null
  
)

export default component.exports